import Image from 'next/image';

import { useFeatureFlag } from '../../hooks/useFeatureFlag';

import paymentAmerican from './images/payment-american.png';
import paymentIdeal from './images/payment-ideal.png';
import paymentPostepay from './images/payment-postepay.png';
import payment from './images/payment.png';

export function PaymentLogo() {
    const { hasFeature } = useFeatureFlag();

    if (hasFeature('payment_ideal')) {
        return <Image alt="" height={40} width={130} src={paymentIdeal} unoptimized />;
    }

    if (hasFeature('payment_american')) {
        return <Image alt="" height={40} width={130} src={paymentAmerican} unoptimized />;
    }

    if (hasFeature('payment_postepay')) {
        return <Image alt="" height={40} width={130} src={paymentPostepay} unoptimized />;
    }

    return <Image alt="" height={40} width={130} src={payment} unoptimized />;
}
